export type BreadCrumb = {
  part: string;
  path: string;
};

export function breadcrumbs(path: string): BreadCrumb[] {
  const parts = path.split('/');
  parts.pop();
  let previousPart = '';
  const breadcrumbs: BreadCrumb[] = [];
  parts.forEach((p, i) => {
    const newPart = `${previousPart}/${p}`;
    breadcrumbs.push({
      path: newPart,
      part: p,
    });
    previousPart = newPart;
  });

  return breadcrumbs;
}
